import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { render } from 'react-dom';
import * as React from 'react';
import { Switch } from './switch';
import { LINK_URL } from '../web-components/utils';
import {
    DeviceType,
    PageType,
    Subvertical,
    Vertical,
} from '../../../shared/types/ast';
import { displayAdsLog } from '../../utils/debug';
import { Event } from '@podium/browser';
import { subscribe, unsubscribe } from '../../podlet/events';

export const NAME = 'ad-switch-web-component';

@customElement(NAME)
export class AdSwitchWebComponent extends LitElement {
    @property({ type: String })
    pageType: PageType = null;

    @property({ type: String })
    vertical: Vertical = null;

    @property({ type: String })
    deviceType: DeviceType = null;

    @property({ type: String })
    subvertical: Subvertical = null;

    @property({ type: String })
    placementId: string = null;

    @property({ type: Boolean })
    grid: boolean = false;

    @property({ type: String, state: true })
    currentPlacementId: string = this.placementId;

    rootName: string = `${NAME}-root`;

    constructor() {
        super();
        displayAdsLog(NAME, this.currentPlacementId, 'constructor()');
    }
    connectedCallback() {
        displayAdsLog(NAME, this.currentPlacementId, 'connectedCallback()');
        super.connectedCallback();
        // set up event listeners or subscriptions
        this.refreshCallback = this.refreshCallback.bind(this);
        subscribe('banner', 'refresh', this.refreshCallback);

        this.currentPlacementId = this.placementId;
    }

    disconnectedCallback() {
        displayAdsLog(NAME, this.currentPlacementId, 'disconnectedCallback()');
        // clean up event listeners or subscriptions
        super.disconnectedCallback();
        unsubscribe('banner', 'refresh', this.refreshCallback);
    }

    refreshCallback(event: Event) {
        displayAdsLog(NAME, this.currentPlacementId, 'refreshCallback()');

        const cycle = event.payload;
        if (cycle) {
            displayAdsLog(`${NAME} ${this.placementId} cycle: ${cycle}`);
            const oldSlot = document.getElementById(this.currentPlacementId);
            displayAdsLog('oldSlot: ', oldSlot);
            while (oldSlot?.firstChild) {
                oldSlot.removeChild(oldSlot.firstChild);
            }

            this.currentPlacementId = this.placementId + cycle;
            this.setSlot();
            // this.renderReact();
        }
    }

    setSlot() {
        displayAdsLog(NAME, this.currentPlacementId, 'setSlot()');
        const id = this.currentPlacementId;
        const slotDiv = document.createElement('div');
        slotDiv.slot = `${id}_slot`;
        // slotDiv.id = id;
        displayAdsLog(NAME, this.currentPlacementId, slotDiv);
        this.appendChild(slotDiv);
    }

    firstUpdated(_changedProperties) {
        displayAdsLog(NAME, this.currentPlacementId, 'firstUpdated()');

        super.firstUpdated(_changedProperties);
        this.currentPlacementId = this.placementId;
        this.setSlot();
    }

    updated(_changedProperties) {
        displayAdsLog(NAME, this.currentPlacementId, 'updated()');
        super.updated(_changedProperties);
        this.renderReact();
    }

    renderReact() {
        displayAdsLog(NAME, this.currentPlacementId, 'renderReact()');
        const props = {
            pageType: this.pageType,
            vertical: this.vertical,
            deviceType: this.deviceType,
            subvertical: this.subvertical,
            placementId: this.placementId,
            className: `grid overflow-hidden relative transition-all outline-none col-span-full ${
                this.subvertical === 'flight' ? 'mt-16' : ''
            }`,
            grid: this.grid,
            slotAd: true,
        };
        displayAdsLog(NAME, this.currentPlacementId, { props });

        render(
            <Switch {...props} />,
            this.shadowRoot.getElementById(this.rootName),
        );
    }

    render() {
        displayAdsLog(NAME, this.currentPlacementId, 'render()');

        return html`
            <link href="${LINK_URL.FABRIC}" rel="stylesheet" />
            <link href=${LINK_URL.ADVT_CSS} rel="stylesheet" />
            <div id="${this.rootName}"></div>
        `;
    }
}
